export default "__VITE_ASSET__D1DdvHtJ__"